module.exports = __webpack_public_path__ + "static/img/info.18bc084d.svg";